import React, { useState, useEffect } from 'react'
import Icon from 'meinian-package/src/component/icon'
import Button from 'meinian-package/src/baseComponent/button'
import classNames from 'classnames'
import request from 'meinian-package/src/utils/request'
import { message } from 'antd'
import Textarea from 'meinian-package/src//component/textarea'
import styles from './index.module.less'

let timer = null

export const RejectCommentWindow = ({ onClose, style, className, chidClassName, data, leaveCommentInitiativeBehavior, onPublish }) => {
  const [count, setCount] = useState(5)
  const [content, setContent] = useState('')
  useEffect(() => {
    if (!leaveCommentInitiativeBehavior) {
      timer = setInterval(() => { setCount(pre => pre - 1) }, 1000)
    } else {
      clearInterval(timer)
    }
    return () => {
      destroy()
    }
  }, [leaveCommentInitiativeBehavior])

  useEffect(() => {
    if (count <= 0) {
      destroy()
    }
  }, [count])

  const destroy = () => {
    setCount(5)
    clearInterval(timer)
    onClose()
  }

  const _onPublish = async () => {
    const success = await request.post('/zhikuan/ins/inspiration/add-user-comment', {
      content,
      commentDesc: '审核不通过',
      ...data
    })
    if (success) {
      onPublish?.()
      message.success('评论成功')
      destroy()
    }
  }

  return <div
    onClick={(e) => e.stopPropagation()}
    className={classNames(styles['mn-card-leave-comment-windows'], className, chidClassName)}
    style={style}
  >
    <div className="mn-card-leave-comment-windows-header">
      <div className="mn-card-leave-comment-windows-header-title">留言评论</div>
      <div
        className="mn-card-leave-comment-windows-header-clear"
        onClick={() => {
          destroy()
        }}
      ><Icon type="m-guanbi" /></div>
    </div>
    <div className="mn-card-leave-comment-windows-textarea-wrap">
      <Textarea
        onBlur={() => {
          timer = setInterval(() => { setCount(pre => pre - 1) }, 1000)
        }}
        onFocus={() => {
          clearInterval(timer)
          setCount(5)
        }}
        wrapClassName="mn-add-inspiration-create-comment mn-card-leave-comment-windows-textarea"
        wrapStyle={{ margin: 0 }}
        placeholder="简单说一下不通过的原因吧"
        minHeight={null}
        maxLength={200}
        value={content}
        onInput={e => setContent(e.target.value)}
      />
      <div className="mn-card-leave-comment-windows-textarea-wrap-number">{content.length} / 200</div>
    </div>
    <div className="mn-card-leave-comment-windows-footer">
      <div>
        {
      !leaveCommentInitiativeBehavior && <div>无任何操作将于 <span style={{ color: '#0065D9 ' }}>{count}s</span> 后自动关闭</div>
    }
      </div>
      <Button type="primary" disabled={!content} style={{ width: 64 }} onClick={() => _onPublish()}>发布</Button>
    </div>
  </div>
}
